import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./assets/app.scss";

//scroll to
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);

Vue.component("Footer", require("./components/Footer.vue").default);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
